@if (label && viewMode !== 'view') {
    <div class = "ui-label">
        {{ label }}
    </div>
}
<div class = "ui-data-selector-container" [ngClass] = "{'ui-data-selector-view': readonly}">
    @if (value && viewMode === 'view') {
        <div class ="ui-select-icon">
            <i class = "{{ icon }}"></i>
        </div>
    }
    <div class = "ui-data-selector">
        @if (readonly) {
            <div class = "ui-detail-container">
                <span class = "ui-sub-title">{{ label }}</span>
                <div class = "ui-title ui-date">{{ value | date: 'd \'de\' MMMM \'de\' y' }}</div>
            </div>
        } @else {
            <div class = "ui-field">
                <i class = "uii-calendar ui-icon" (click) = "picker.open()"></i>
                <input matInput [matDatepicker] = "picker" [(ngModel)] = "selectedDateMenu" style = "height: 0; padding: 0; border: unset !important;">
                <input [(ngModel)] = "selectedDate" [placeholder] = "placeholder || 'Data...'" (input) = "eventDateChanged()" mask="00/00/0000" [dropSpecialCharacters]="false">

                <!-- todo criar um componente de datepicker interno sem depender do Angular material -->
                <mat-datepicker #picker yPosition = "above" (closed) = "eventDateChangedFromMenu()"></mat-datepicker>
            </div>
        }
    </div>
</div>
